"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = _interopRequireDefault(require("./constants"));

var _Utils = _interopRequireDefault(require("./Utils"));

var _thdUserInfo = require("./thdUserInfo");

var _page = require("./Page/page");

var _addToCart = require("./AddToCart/addToCart");

var _addToCartLocation = require("./AddToCart/addToCartLocation");

var _buttonSubmission = require("./ButtonSubmission/buttonSubmission");

function _createSuper(Derived) { return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// ddoInit initializes the core code. It should fire as early as possible
// once the digitalData values are populated (e.g. page load).
// ddoEventInit fires on separate calls after page load (e.g. button clicks)
var AnalyticsStrategy = function AnalyticsStrategy() {
  (0, _classCallCheck2["default"])(this, AnalyticsStrategy);
  (0, _defineProperty3["default"])(this, "createAddToCartEvent", function (item) {
    return (0, _addToCart.createAddToCartEvent)(item);
  });
  (0, _defineProperty3["default"])(this, "createAddToCartLocationEvent", function (stash) {
    return (0, _addToCartLocation.createAddToCartLocationEvent)(stash);
  });
  (0, _defineProperty3["default"])(this, "createButtonSubmissionEventWithEventName", function (eventName) {
    return (0, _buttonSubmission.createButtonSubmissionEventWithEventName)(eventName);
  });
  (0, _defineProperty3["default"])(this, "createButtonSubmissionEventWithEventNameAndItem", function (eventName, item) {
    return (0, _buttonSubmission.createButtonSubmissionEventWithEventNameAndItem)(eventName, item);
  });
  (0, _defineProperty3["default"])(this, "createPageObject", function (pageName, pageType, primaryCategory, subCategory1, subCategory2) {
    return (0, _page.createPageObject)(pageName, pageType, primaryCategory, subCategory1, subCategory2);
  });
  (0, _defineProperty3["default"])(this, "createSiteObject", function (betaSite, experienceType, siteId) {
    return (0, _page.createSiteObject)(betaSite, experienceType, siteId);
  });
  (0, _defineProperty3["default"])(this, "sendAnalyticsEvent", function () {});
  (0, _defineProperty3["default"])(this, "sendPageLoadEvent", function () {});
};

var THDAnalyticsStrategy = /*#__PURE__*/function (_AnalyticsStrategy) {
  (0, _inherits2["default"])(THDAnalyticsStrategy, _AnalyticsStrategy);

  var _super = _createSuper(THDAnalyticsStrategy);

  function THDAnalyticsStrategy() {
    var _this;

    (0, _classCallCheck2["default"])(this, THDAnalyticsStrategy);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "sendAnalyticsEvent", function (thdAnalyticsEvent) {
      var timeOut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants["default"].DefaultTimeOut;
      return new Promise(function (resolve) {
        if (window.digitalData) {
          window.digitalData.event.push(thdAnalyticsEvent);
          window.setTimeout(resolve(), timeOut);
        }
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "sendPageLoadEvent", function (pageObject, siteObject) {
      if (window.digitalData) {
        window.digitalData.page = pageObject;
        window.digitalData.site = siteObject;

        if (!_Utils["default"].doesPropertyExist(window.digitalData, _constants["default"].PropertyPaths.UserProfileAuthenticationStatus)) {
          _Utils["default"].setUserProfileAuthenticationStatus((0, _thdUserInfo.getAuthenticationStatus)());
        }

        window.ddoInit(window.digitalData);
      }
    });
    return _this;
  }

  return THDAnalyticsStrategy;
}(AnalyticsStrategy);

var BlindsComAnalyticsStrategy = /*#__PURE__*/function (_AnalyticsStrategy2) {
  (0, _inherits2["default"])(BlindsComAnalyticsStrategy, _AnalyticsStrategy2);

  var _super2 = _createSuper(BlindsComAnalyticsStrategy);

  function BlindsComAnalyticsStrategy() {
    var _this2;

    (0, _classCallCheck2["default"])(this, BlindsComAnalyticsStrategy);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this2), "sendAnalyticsEvent", function (bcomAnalyticsEvent) {
      var timeOut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants["default"].DefaultTimeOut;
      return new Promise(function (resolve) {
        if (window.digitalData) {
          window.ddoEventInit(bcomAnalyticsEvent);
          window.setTimeout(resolve(), timeOut);
        }
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this2), "sendPageLoadEvent", function (pageObject, siteObject) {
      if (window.digitalData) {
        window.digitalData.page = pageObject;
        window.digitalData.site = siteObject;
        window.ddoInit(window.digitalData);
      }
    });
    return _this2;
  }

  return BlindsComAnalyticsStrategy;
}(AnalyticsStrategy);

var AnalyticsContext = function AnalyticsContext(_siteId) {
  var _defineProperty2,
      _this3 = this;

  (0, _classCallCheck2["default"])(this, AnalyticsContext);
  (0, _defineProperty3["default"])(this, "strategies", (_defineProperty2 = {}, (0, _defineProperty3["default"])(_defineProperty2, _constants["default"].Sites.Blinds, new BlindsComAnalyticsStrategy()), (0, _defineProperty3["default"])(_defineProperty2, _constants["default"].Sites.TheHomeDepot, new THDAnalyticsStrategy()), _defineProperty2));
  (0, _defineProperty3["default"])(this, "createAddToCartEvent", function (item) {
    return _this3.strategy.createAddToCartEvent(item);
  });
  (0, _defineProperty3["default"])(this, "createAddToCartLocationEvent", function (stash) {
    return _this3.strategy.createAddToCartLocationEvent(stash);
  });
  (0, _defineProperty3["default"])(this, "createButtonSubmissionEventWithEventName", function (eventName) {
    return _this3.strategy.createButtonSubmissionEventWithEventName(eventName);
  });
  (0, _defineProperty3["default"])(this, "createButtonSubmissionEventWithEventNameAndItem", function (eventName, item) {
    return _this3.strategy.createButtonSubmissionEventWithEventNameAndItem(eventName, item);
  });
  (0, _defineProperty3["default"])(this, "createPageObject", function (pageName, pageType, primaryCategory, subCategory1, subCategory2) {
    return _this3.strategy.createPageObject(pageName, pageType, primaryCategory, subCategory1, subCategory2);
  });
  (0, _defineProperty3["default"])(this, "createSiteObject", function (betaSite, experienceType, siteId) {
    return (0, _page.createSiteObject)(betaSite, experienceType, siteId);
  });
  (0, _defineProperty3["default"])(this, "sendAnalyticsEvent", function (analyticsEvent) {
    var timeOut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants["default"].DefaultTimeOut;

    _this3.strategy.sendAnalyticsEvent(analyticsEvent, timeOut);
  });
  (0, _defineProperty3["default"])(this, "sendPageLoadEvent", function (pageObject, siteObject) {
    _this3.strategy.sendPageLoadEvent(pageObject, siteObject);
  });
  this.strategy = this.strategies[_siteId];
};

exports["default"] = AnalyticsContext;
//# sourceMappingURL=AnalyticsContext.js.map